import axios from 'axios'

type SetAuthorizedSrcParams = {
  element: HTMLImageElement
  getAuthorization: () => Promise<string>
  src: string
}

/**
 * 認証されたリクエストで画像を取得し、HTMLImageElementに設定します。
 *
 * @param params - パラメーター。
 * @param params.element - 画像を設定するHTMLImageElement。
 * @param params.getAuthorization - 認証トークンを取得する関数。
 * @param params.src - 取得する画像のURL。
 */
export async function setAuthorizedSrc({
  element,
  getAuthorization,
  src,
}: SetAuthorizedSrcParams) {
  const authorization = await getAuthorization()

  const getAxiosResult = async () => {
    try {
      return await axios.get(src, {
        headers: { authorization },
        responseType: 'blob',
      })
    } catch (_error) {
      return null
    }
  }
  const axiosResult = await getAxiosResult()

  if (axiosResult?.status !== 200) {
    return
  }

  const objectURL = URL.createObjectURL(axiosResult.data)
  const revokeObjectURL = () => {
    URL.revokeObjectURL(objectURL)
  }

  element.onerror = revokeObjectURL
  element.onload = revokeObjectURL
  element.src = objectURL
}
